import { useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation, Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setToast } from "../../redux/slice/system";
import { setUser } from "../../redux/slice/user";
import { usePop } from "../hooks";
import moment from "moment";

import FrontHeader from "./header";
import FrontFooter from "./footer";
import ModulePopCheckToken from "../backLayout/popCheckToken";
import ModulePopSecurity from "./popSecurity";

import LayoutCss from "../../styles/components/layout.module.scss";
import { classNames } from "primereact/utils";

export default function MemberLayoutMain(props) {
  const redux_user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const route_location = useLocation();
  const route_navigate = useNavigate();
  const { isPop, openPop, closePop, renderDialog } = usePop([
    {
      key: "refreshToken",
      title: () => "確認",
      isOpen: false,
    },
    {
      key: "security",
      title: () => "個資安全聲明",
      isOpen: false,
    },
  ]);
  // 是否有權限
  const [authSetting, setAuthSetting] = useState({
    isValid: null,
    optionPath: {
      1: ["/member"],
    },
    commonPath: [],
  });

  // 偵測是否有登入資料，沒有則導回登入頁
  useEffect(() => {
    let user_local = localStorage.getItem("user");
    if (user_local) user_local = JSON.parse(user_local);

    if (
      (!redux_user.userDetail && !user_local) ||
      (redux_user.userDetail && [8, 9].includes(redux_user.userDetail.type)) ||
      (user_local && [8, 9].includes(user_local.type))
    ) {
      route_navigate("/login");
    } else if (!redux_user.userDetail?.is_agree && !user_local?.is_agree) {
      openPop({ type: "security" });
    }
  }, [redux_user]);

  useEffect(() => {
    let timer = setInterval(() => {
      if (redux_user.userDetail) {
        let diff = moment().diff(redux_user.userDetail?.now);
        if (diff >= 3 * 60 * 60 * 1000 || !redux_user.userDetail?.now) {
          dispatch(
            setToast({
              severity: "error",
              summary: "超過使用時限，請重新登入",
              detail: "",
            })
          );
          dispatch(setUser(null));
          route_navigate("/login");
        } else if (
          diff >= 3 * 60 * 60 * 1000 - 15 * 60 * 1000 ||
          !redux_user.userDetail?.now
        ) {
          openPop({
            type: "refreshToken",
            data: null,
          });
        }
      } else {
        clearInterval(timer);
      }
    }, 5000);

    return () => {
      clearInterval(timer);
    };
  }, [redux_user.userDetail]);

  // 判斷頁面權限
  useEffect(() => {
    if (!redux_user.userDetail) return;

    let isValid = false;
    if ([8, 9].includes(redux_user.userDetail?.type)) isValid = true;
    else {
      isValid = (authSetting.optionPath[redux_user.userDetail?.type] || [])
        ?.concat(authSetting.commonPath)
        .some((path) => route_location.pathname.includes(path));
    }
    setAuthSetting((state) => ({ ...state, isValid }));
  }, [redux_user]);

  /*
   * 無權限頁面跳轉
   * 已登入 => 跳轉上一頁
   * 未登入 => 跳轉登入
   */
  useEffect(() => {
    if (redux_user.userDetail && authSetting.isValid === false)
      route_navigate(-1);
    else if (authSetting.isValid === false) route_navigate("login");
  }, [authSetting]);

  return (
    <>
      <div
        className={classNames(
          "flex flex-column min-h-screen",
          LayoutCss["layout-front-wrap"]
        )}
      >
        <FrontHeader LayoutCss={LayoutCss} />
        <div className="flex flex-column flex-auto w-12 md:w-10 max-w-60rem mx-auto p-3">
          {/* 內容區塊，依照 route 顯示不同元件 */}
          {redux_user.userDetail && authSetting.isValid && <Outlet />}
        </div>
        <FrontFooter />
      </div>

      {renderDialog({
        className: "w-11 lg:w-8 md:w-9 sm:w-10 max-w-30rem",
        closable: isPop.security?.isOpen ? false : true,
        children: (
          <>
            {isPop.refreshToken?.isOpen && (
              <ModulePopCheckToken closePrePop={closePop} />
            )}
            {isPop.security?.isOpen && (
              <ModulePopSecurity closePrePop={closePop} />
            )}
          </>
        ),
      })}
    </>
  );
}
